import { ToggleButton, ToggleButtonGroup } from '@backstage/ui';
import { HISTORY_DAYS, type HistoryDays } from '@internal/scorecards-common';

interface RangeToggleProps {
  value: HistoryDays;
  onChange: (days: HistoryDays) => void;
}

export const RangeToggle = ({ value, onChange }: RangeToggleProps) => (
  <ToggleButtonGroup
    selectionMode="single"
    disallowEmptySelection
    selectedKeys={new Set([String(value)])}
    onSelectionChange={keys => {
      const [first] = [...keys];
      if (first !== undefined) onChange(Number(first) as HistoryDays);
    }}
    aria-label="History range"
  >
    {HISTORY_DAYS.map(d => (
      <ToggleButton key={d} id={String(d)} size="small">
        {d} days
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);
